import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import context

const Header = () => {
  const { isAuthenticated, handleLogout } = useAuth(); // ✅ Get state from context

  return (
    <header className="bg-teal-900 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6 sm:flex-row flex-col">
          {/* Logo */}
          <div className="flex items-center mb-4 sm:mb-0">
            <Link to="/" className="flex items-center">
              <img
                src="/assets/icons/main_icon.png"
                alt="API Logo"
                className="w-10 h-10 mr-3"
              />
              <h1 className="text-white text-2xl font-bold">IBAN API</h1>
            </Link>
          </div>

          {/* Navigation */}
          <nav className="flex flex-col sm:flex-row text-center sm:text-left space-y-2 sm:space-y-0 sm:space-x-4 items-center">
            {/* Home or Dashboard depending on auth */}
            <Link
              to={isAuthenticated ? "/dashboard" : "/"}
              className="text-white font-medium hover:underline"
            >
              {isAuthenticated ? "Dashboard" : "Home"}
            </Link>

            {/* API Docs - Always visible */}
            <Link to="/api-docs" className="text-white font-medium hover:underline">
              API Docs
            </Link>

            {/* API Docs - Always visible */}
            <Link to="/pricing" className="text-white font-medium hover:underline">
              Pricing
            </Link>

            {/* API Docs - Always visible */}
            <Link to="/countries" className="text-white font-medium hover:underline">
              Countries
            </Link>

            {/* Auth links or Logout */}
            {!isAuthenticated ? (
              <>
                <Link to="/signup" className="text-white font-medium hover:underline">
                  Sign Up
                </Link>
                <Link to="/login" className="text-white font-medium hover:underline">
                  Login
                </Link>
              </>
            ) : (
              <button
                onClick={handleLogout}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Logout
              </button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
